import { useEffect } from 'react';
import { Link } from 'react-router';

import { clearProviderMarker } from '../auth/session-provider';

/**
 * The signed-out interstitial.
 *
 * Logout MUST land here, never on /auth/login: the browser still holds a live
 * oauth.yandex.ru session, so pointing a logout straight at the login hop makes
 * Yandex answer silently and the user is back in the app before they noticed
 * they logged out (production bug on the previous boilerplate — see
 * LLM_CONTEXT/02-auth.md, gotcha #4). This page makes the signed-out state
 * explicit; going back in is a deliberate click.
 *
 * T.Y18 (owner, live testing): that deliberate click is now «Войти снова», and it
 * goes to `/login` — the same card layout the sign-in screen renders, with BOTH
 * doors on it (the Yandex hop for staff, the e-mail code for curators) instead of
 * this page duplicating one of them. The direct OAuth anchor the page used to carry
 * was the silent-re-login trap above in miniature: one click could skip the login
 * screen and hand a still-live provider session straight back.
 */
export function LoggedOutPage() {
  // T.Y8 — the session's provider marker dies here too: a code login in a tab
  // must not make the NEXT session in that tab look like a cabinet session.
  useEffect(() => clearProviderMarker(window.sessionStorage), []);

  return (
    <div className="interstitial">
      <div className="interstitial__card">
        <span className="interstitial__logo" aria-hidden="true">
          CB
        </span>
        <h1>Вы вышли из системы</h1>
        <p>Сессия закрыта. Войдите снова, когда будете готовы.</p>
        {/* A client-side hop to the login screen: nothing here starts the OAuth
            redirect chain, so no live provider session can leak back in. */}
        <Link className="btn btn--primary" to="/login" data-testid="sign-in-again">
          Войти снова
        </Link>
      </div>
    </div>
  );
}
